module.exports = __webpack_public_path__ + "assets/img/character_kinesis.9b1fd0b7.png";